module.exports = __webpack_public_path__ + "media/base/block-85dbc3f3.svg";